import React from "react";
import {BTN_BASE, BTN_SIZES, BTN_VARIANTS, ButtonSize, ButtonVariant} from "../button-const.ts";
import mergeClasses from "../../../utils/merge-classes.ts";

interface ExternalLinkButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement>{
    variant?: ButtonVariant;
    size?: ButtonSize;
}

const ExternalLinkButton: React.FC<ExternalLinkButtonProps> = ({variant = 'primary', size = 'sm', href, className, ...props }: ExternalLinkButtonProps) => (
    <a href={href} className={mergeClasses(BTN_BASE, BTN_VARIANTS[variant], BTN_SIZES[size], className)}>
      {props.children}
    </a>
  );

export default ExternalLinkButton;